<template>
  <div class="top_bg" style="overflow-y: scroll;background-color: #FEB1DD;">
    <div class="week_bg" style="background-image: url('img/seventhMoon/top_bg.png');background-size: 100% 100%;background-repeat: no-repeat;">
      <back-nav :icon="'img/backb.png'" :textColor="'#111'" :backColor="'none'" />
      <div class="week_date_bg" style="background-image: url(img/seventhMoon/w_date_bg.png);">
        <div class="week_date_title">{{'活动时间：'+actDate}}</div>
      </div>
      <div class="st_rule" style="background-image: url(img/seventhMoon/w_rule.png);" @click="goRule"></div>
      
    </div>
      <div class="house" style="background-image: url('img/seventhMoon/house.png');"></div>
      <template>
        <!-- 活动进行中 -->
        <div v-if="mode == 1" class="week_gift display_flex justify-content_flex-justify align-items_center"
          style="background-image: url(img/seventhMoon/w_box1.png);">
          <div class="week_gift_box">
             <div v-if="loading" class="w_loading">加载中...</div>
          <div class="w_item_box" v-for="(item, index) in giftInfo" :key="index">
            <div class="w_item display_flex flex-direction_column justify-content_flex-center align-items_center">
            <div class="w_img display_flex justify-content_flex-center align-items_center">
              <img :src="item.gift_url" alt="">
            </div>
          </div>
          <!-- <div class="light" style="background-image: url(img/seventhMoon/light.png);"></div> -->
          <p style="color:#FF79DC ;">{{ item.gift_name }}</p>
            <div class="display_flex align-items_center" style="margin-top: 7px;">
              <span style="color: #FF79DC;">{{ item.gold }}</span>
              <img class="bi" src="img/sliver.png" alt="">                                                                              
            </div>
          </div>
          </div>
         
        
        </div>
        <!-- 活动结束 -->
        <div v-if="mode == 2" class="week_gift display_flex justify-content_flex-center align-items_center"
          style="background-image: url(img/seventhMoon/w_boxOver1.png);">
           <div class="week_gift_box">
             <div v-if="loading" class="w_loading">加载中...</div>
          <div class="w_item_box" v-for="(item, index) in giftInfo" :key="index">
            <div class="w_item display_flex flex-direction_column justify-content_flex-center align-items_center">
            <div class="w_img display_flex justify-content_flex-center align-items_center">
              <img :src="item.gift_url" alt="">
            </div>
          </div>
          <!-- <div class="light" style="background-image: url(img/seventhMoon/light.png);"></div> -->
          <p style="color: #9A223F;">{{ item.gift_name }}</p>
            <div class="display_flex align-items_center" style="margin-top: 7px;">
              <span style="color: #9A223F;">{{ item.diamonds }}</span>
              <img class="bi" src="img/bi.png" alt="">                                                                              
            </div>
          </div>
          </div>
       
        </div>
      </template>
         <div class="display_flex align-items_center" style="justify-content: space-around;margin-top: 28px;">
          <div class="week_nav"
          :style="{ backgroundImage: navCur == index ? `url(img/seventhMoon/navActive${index}_.png)` : `url(img/seventhMoon/nav${index}_.png)` }"
            v-for="(item, index) in nav" :key="index" @click="changeNav(index)"></div>
        </div>
      <div class="week_rank" style="background-image: url('img/seventhMoon/main_bg.png');"> 
        <!-- <div class="week_title" style="background-image: url(img/seventhMoon/w_title.png);"></div> -->
        <div v-if="loading" class="w_loading">加载中...</div>
        <div class="week_top" v-if="oneData">
          <!-- 第一名 -->
          <div class="week_one display_flex flex-direction_column align-items_center" v-if="oneData">
            <div class="top_one" style="background-image: url('img/seventhMoon/top_one.png')">
              <img class="one_head" :src="oneData.head_portrait" alt="">
              </div>
              <div class="one_title" style="background-image: url('img/seventhMoon/one.png');"></div>
                <div class="week_name display_flex justify-content_flex-center align-items_center">
              <p>{{ oneData.nickname }}</p>
            </div>
            <div class="week_id">ID:{{ oneData.uid }}</div>
            <div class="week_value" v-if="mode == 1">{{ nav[navCur].value }}
              <span>{{ oneData.total_value }}</span>
            </div>
          </div>
          <!-- 第二名 -->
          <div class="week_two display_flex flex-direction_column align-items_center" v-if="twoData">
            <div class="top_two" style="background-image: url('img/seventhMoon/top_two.png')">
              <img class="two_head" :src="twoData.head_portrait" alt="">
          
            </div>
            <div class="one_title" style="background-image: url('img/seventhMoon/two.png');"></div>
                <div class="week_nickname week_right">{{ twoData.nickname }}</div>
            <div class="week_id week_right">ID:{{ twoData.uid }}</div>
            <div class="week_value week_right" v-if="mode == 1">{{ nav[navCur].value }} {{ twoData.total_value }}</div>
          </div>
          <!-- 第三名 -->
          <div class="week_third display_flex flex-direction_column align-items_center" v-if="thirdData">
            <div class="top_two" style="background-image: url('img/seventhMoon/top_three.png')">
              <img class="two_head" :src="thirdData.head_portrait" alt="">
         
            </div>
            <div class="one_title" style="background-image: url('img/seventhMoon/three.png');"></div>
                 <div class="week_nickname week_left">{{ thirdData.nickname }}</div>
            <div class="week_id week_left">ID:{{ thirdData.uid }}</div>
            <div class="week_value week_left" v-if="mode == 1">{{ nav[navCur].value }} {{ thirdData.total_value }}</div>
          </div>
        </div>
        <div class="week_three_bg" style="background-image: url('img/seventhMoon/top_three_bg.png');"></div>
        <!-- 第四名往后 -->
        <div class="week_listMg" v-if="mode == 1">
          <div :class="index%2 ==0?'week_view_ display_flex justify-content_flex-justify align-items_center':'week_view display_flex justify-content_flex-justify align-items_center'" v-for="(item, index) in list"
            :key="index">
            <div class="display_flex align-items_center">
              <div class="week_three">{{ index + 4 }}</div>
              <img class="week_head" :src="item.head_portrait" alt="">
              <div class="week_people">
                <p>{{ item.nickname }}</p>
                <span>ID:{{ item.uid }}</span>
              </div>
            </div>
            <div class="week_cp margin-right-sm">
              <p>{{ item.total_value }}</p>
              <span>{{ nav[navCur].value }}</span>
            </div>
          </div>
        </div>
        <!-- 自己排行 -->
        <div class="week_my" v-if="my_value > 0">我距离第五十名{{ nav[navCur].value }}：{{ my_value }}</div>
        <!-- 无数据 -->
        <div v-if="noData" class="noData">
          <img src="img/seventhMoon/noData.png" alt="">
        </div>
      </div>
      <div class="bottom_tip">本活动最终解释权归本平台所有</div>
    </div>
</template>

<script>
import "@/assets/css/base.css"
import "@/assets/css/seventh.css"
import BackNav from "@/components/backNav.vue";
import { ActivityWeek } from "@/api/api";

export default {
  name: 'weekStarRank',
  components: {
    BackNav,
  },
  data() {
    return {
      nav: [
        {
          name: '周星魅力榜',
          value: '魅力值'
        },
        {
          name: '周星财富榜',
          value: '财富值'
        }],
      navCur: 0,
      list: [],
      giftInfo: [],
      loading: true,
      my_value: null,
      noData: false,
      oneData: null,
      twoData: null,
      thirdData: null,
      mode: 1,
      actDate: null,
      weekGift:{}
    }
  },
  created() {
    let access_token = this.$route.query.access_token
    localStorage.setItem('access_token', access_token)
    this.getData()
  },
  methods: {
    getData() {
      let type = this.navCur + 1
      ActivityWeek({ type }).then(response => {
        this.loading = false
        let [oneData = null, twoData = null, thirdData = null, ...list] = response.data.data.data
        this.oneData = oneData
        this.twoData = twoData
        this.thirdData = thirdData
        this.list = list
        this.actDate = response.data.date
        this.weekGift = response.data.collection_gift
        this.my_value = response.data.data.dis_value
        if(response.data.mode==2){
          this.giftInfo = [response.data.data.giftInfo]
        }else{
          this.giftInfo = response.data.data.giftInfo
        }
      
        this.mode = response.data.mode
        if (response.data.data.data.length == 0) {
          this.noData = true
        }
      },
        error => {
          this.loading = false
          this.noData = true
          this.$toast.fail(error)
        }).catch((error) => {
          this.loading = false
          this.noData = true
          this.$toast.fail(error)
        })
    },
    changeNav(e) {
      this.navCur = e
      this.getData()
    },
    goRule() {
      this.$router.push({ path: '/weekStarRule?data='+JSON.stringify(this.weekGift) })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
